(function () {
  function ensureCad(el) {
    if (!el || el.dataset.cadPatching === 'true') return;
    var text = el.textContent || '';
    if (/CAD\s*$/.test(text.trim())) return;
    el.dataset.cadPatching = 'true';
    el.textContent = text.replace(/\s+$/, '') + ' CAD';
    el.dataset.cadPatching = 'false';
  }

  function init() {
    var priceEl = document.querySelector('[data-product-price]');
    if (!priceEl) return;

    ensureCad(priceEl);

    var observer = new MutationObserver(function () {
      if (priceEl.dataset.cadPatching === 'true') return;
      ensureCad(priceEl);
    });
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
